import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ThreeWordsOfText'
})
export class ThreeWordsOfTextPipe implements PipeTransform {

  transform(value: any): string {
    const Text = value.toString();
    let list = Text.split(' ');
    if (list.length > 3) {
      return list[0] + ' ' + list[1] + ' ' + list[2] + ' ...';
    } else {
      return Text
    }
  }

}
